import { c as _c } from "react/compiler-runtime";
import { FaroTable } from "@components/common/faro-table/faro-table";
import { getMemberGroupProjectsColumns } from "@components/table/member-group-projects/member-group-projects-columns";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useMediaQueryList } from "@hooks/use-media-query";
import { Box } from "@mui-wrapper";
import { useCompanyId } from "@context-providers/company-id-provider";
import { useAppDispatch } from "@store/store-helper";
import { resetTableState, setTableType } from "@store/table/table-slice";
import { ProjectEvents, TableType } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useEffect, useCallback } from "react";
/**
 * Listing all the projects in a group that a member belongs to
 */
export function MemberGroupProjectsTable(t0) {
  const $ = _c(29);
  const {
    projects,
    member,
    onMemberRemoved,
    onRoleChanged,
    isLoading,
    requiredColumns,
    bulkActionButtons,
    shouldHideCheckbox: t1
  } = t0;
  const shouldHideCheckbox = t1 === undefined ? true : t1;
  const dispatch = useAppDispatch();
  const {
    isScreenMd,
    isScreenLgOrLarger
  } = useMediaQueryList();
  const {
    navigateToProjectDetail
  } = useAppNavigation();
  const companyId = useCompanyId();
  const {
    trackEvent
  } = useTrackEvent();
  const isRowSelectable = _temp;
  let t2;
  let t3;
  if ($[0] !== dispatch) {
    t2 = () => {
      dispatch(setTableType(TableType.memberGroupProjects));
      return () => {
        dispatch(resetTableState());
      };
    };
    t3 = [dispatch];
    $[0] = dispatch;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      pb: "24px"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      "& .MuiDataGrid-row": {
        cursor: "pointer"
      }
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== isScreenLgOrLarger || $[6] !== isScreenMd || $[7] !== member || $[8] !== onMemberRemoved || $[9] !== onRoleChanged || $[10] !== requiredColumns) {
    let t7;
    if ($[12] !== isScreenLgOrLarger || $[13] !== isScreenMd || $[14] !== member || $[15] !== onMemberRemoved || $[16] !== onRoleChanged) {
      t7 = requiredColumn => getMemberGroupProjectsColumns({
        member,
        onMemberRemoved,
        onRoleChanged,
        options: {
          isScreenLgOrLarger,
          isScreenMd
        }
      })[requiredColumn];
      $[12] = isScreenLgOrLarger;
      $[13] = isScreenMd;
      $[14] = member;
      $[15] = onMemberRemoved;
      $[16] = onRoleChanged;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    t6 = requiredColumns.map(t7);
    $[5] = isScreenLgOrLarger;
    $[6] = isScreenMd;
    $[7] = member;
    $[8] = onMemberRemoved;
    $[9] = onRoleChanged;
    $[10] = requiredColumns;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[18] !== companyId || $[19] !== navigateToProjectDetail || $[20] !== trackEvent) {
    t7 = project => {
      trackEvent({
        name: ProjectEvents.openProjectDetails,
        props: {
          projectId: project.id,
          eventLocation: "user-profile-group-projects"
        }
      });
      navigateToProjectDetail({
        companyId,
        projectId: project.id
      });
    };
    $[18] = companyId;
    $[19] = navigateToProjectDetail;
    $[20] = trackEvent;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  let t8;
  if ($[22] !== bulkActionButtons || $[23] !== isLoading || $[24] !== projects || $[25] !== shouldHideCheckbox || $[26] !== t6 || $[27] !== t7) {
    t8 = <Box component="div" sx={t4}><FaroTable entities={projects} uniqueIdKey="id" isLoading={isLoading} sx={t5} columns={t6} bulkActionButtons={bulkActionButtons} rowHeight={70} shouldHideCheckbox={shouldHideCheckbox} isRowSelectable={isRowSelectable} shouldHideHeader={true} shouldSkipDynamicHeight={true} tableType={TableType.memberGroupProjects} onRowClick={t7} /></Box>;
    $[22] = bulkActionButtons;
    $[23] = isLoading;
    $[24] = projects;
    $[25] = shouldHideCheckbox;
    $[26] = t6;
    $[27] = t7;
    $[28] = t8;
  } else {
    t8 = $[28];
  }
  return t8;
}
function _temp(params) {
  return params.row.entity?.role !== "RESOURCE_OWNER";
}